import React from 'react';
import classNames from 'classnames';
import {ThemeProvider} from '@material-ui/core/styles';
import {createTheme} from '@material-ui/core/styles';
import {withStyles} from '@material-ui/core/styles';
import axios from 'axios';
import NavigationDrawer from "../../components/Common/NavigationDrawer.js";
import {withRouter} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DashboardTemplateMobile from "./DashboardTemplateMobile";
import { AuthenticationService } from '../../Services/AuthenticationService';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import ListSubheader from '@material-ui/core/ListSubheader';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import SyncIcon from '@material-ui/icons/Sync';

let globalProps;

const drawerWidth = 220;

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
    },
    syncButtonDrawerOpen: {
        position: 'fixed',
        left: '8px',
        top: '80px', // Position below the drawer toggle button
        width: '204px', // drawerWidth - 16px (accounting for padding)
        backgroundColor: '#4ac4cb',
        color: '#000',
        padding: theme.spacing(1.5),
        fontSize: '14px',
        fontWeight: 'bold',
        zIndex: 9999, // Highest z-index
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        '@media (max-width: 1640px)': {
            left: 'auto',
            right: '75px',
            top: '8px',
            width: 'auto',
            minWidth: '204px',
        },
    },
    syncButtonDrawerClosed: {
        position: 'fixed',
        left: '7px', // Centered in the 57px closed drawer (57-45)/2 = 6px
        top: '80px', // Position below the drawer toggle button
        width: '45px',
        height: '45px',
        minWidth: '45px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#4ac4cb',
        color: '#000',
        padding: 0,
        margin: 0,
        borderRadius: '50%',
        zIndex: 9999, // Highest z-index
        boxSizing: 'border-box',
        '& .MuiButton-startIcon': {
            margin: 0,
            marginLeft: 0,
            marginRight: 0,
        },
        '&:hover': {
            backgroundColor: '#1565c0',
        },
        '@media (max-width: 1640px)': {
            left: 'auto',
            right: '75px',
            top: '8px',
            width: 'auto',
            minWidth: '204px',
            height: 'auto',
            borderRadius: '4px',
            padding: theme.spacing(1.5),
            fontSize: '14px',
            fontWeight: 'bold',
        },
    },
    mainAppBar: {
        minHeight: 60,
        paddingLeft: 0,
        paddingRight: 0
    },
    appBar: {
        backgroundColor: '#121212 !important',
        color: '#6e7b8e !important',
        boxShadow: 'none',
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth - 60}px)`,
        paddingLeft: 60
    },
    appBarShift: {
        marginLeft: 0,
        width: '100%',
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    closeImg: {cursor: 'pointer', float: 'right', marginTop: '4px', width: '30px'},
    menuButton: {
        marginLeft: 5,
        marginRight: 13,
    },
    userMenuButton: {
        marginRight: 33,
        fontSize: 16,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: window.innerWidth < 960 ? 0 : drawerWidth,
        display: window.innerWidth < 960 ? 'none' : 'block',
        backgroundColor: '#004612 !important',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        zIndex: '1202'
    },
    drawerOpen: {
        width: drawerWidth - 1,
        display: 'block !important',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        backgroundColor: '#121212 !important',
        color: "#FFF !important",
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: 57 + 'px',
        [theme.breakpoints.up('sm')]: {
            width: 57 + 'px',
        },
        backgroundColor: '#121212 !important',
        color: "#FFF !important",
    },
    toolbar: {
        display: 'block',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0',
        margin: '0 auto',
        minHeight: '50px !important',
    },
});


class DashboardTemplate extends React.Component {

    constructor(props) {
        super(props);
        globalProps = props;
        
        const authService = AuthenticationService.getInstance();
        if (!authService.isLoggedIn()) {
            globalProps.history.push('/login/redirect');
        } else if (!authService.isAdministrator()) {
            authService.denyNonAdministratorAccess();
        } else {
            this.loadUser();
        }
    }

    loadUser() {
        const authService = AuthenticationService.getInstance();
        const user = authService.getUser();
        
        this.state = {
            user: user,
            loading: false,
            jwtToken: authService.getToken(),
            open: true,
            anchorEl: null
        };
    }

    componentDidMount() {
        this.updateDocumentTitle();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.title !== this.props.title) {
            this.updateDocumentTitle();
        }
    }

    updateDocumentTitle() {
        if (this.props.title) {
            document.title = this.props.title;
        }
    }

    toggleNavDrawer = (isOpen) => {
        if (isOpen) {
            this.setState({open: !this.state.open});
        } else {
            this.setState({open: !isOpen});
        }
    };

    handleProfileMenuOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleProfileMenuClose = () => {
        this.setState({ anchorEl: null });
    };

    handleMyProfile = () => {
        this.handleProfileMenuClose();
        if (window.innerWidth <= 960) {
            globalProps.history.push('/profile');
        } else {
            globalProps.history.push('/admin/profile');
        }
    };

    handleLogout = () => {
        this.handleProfileMenuClose();
        this.logout();
    };

    getInitials = (name) => {
        if (!name) return 'U';
        const names = name.split(' ');
        if (names.length === 1) {
            return names[0].charAt(0).toUpperCase();
        }
        return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
    };

    render() {
        const {classes} = this.props;

        const authService = AuthenticationService.getInstance();
        if (!authService.isLoggedIn()) {
            window.location.reload();
            return '';
        }
        if (!authService.isAdministrator()) {
            authService.denyNonAdministratorAccess();
            return '';
        }

        // Create a Material-UI v4 theme
        const theme = createTheme({
            palette: {
                primary: {
                    main: '#1976d2',
                },
                secondary: {
                    main: '#dc004e',
                },
            },
        });

        if (window.innerWidth <= 960) {
            return <ThemeProvider theme={theme}>
                <DashboardTemplateMobile children={this.props.children} title={this.props.title} logout={this.logout}/>
            </ThemeProvider>;
        }
        
        return (
            <ThemeProvider theme={theme}>
                <div className={classes.root}>
                    <AppBar
                        position="fixed"
                        className={classNames(classes.appBar, {
                            [classes.appBarShift]: !this.state.open,
                        })}
                    >
                        <Toolbar disableGutters={!this.state.open} className={classes.mainAppBar}>
                            <div style={{ flexGrow: 1 }} />
                            <span className="dashboard-template-title" onClick={this.toggleNavDrawer} style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
                                {this.props.title ?
                                    <span> {this.props.title}</span>
                                    : ''
                                }
                            </span>
                            <div style={{ flexGrow: 1 }} />
                            <IconButton
                                onClick={this.handleProfileMenuOpen}
                                style={{
                                    marginRight: '20px',
                                    backgroundColor: '#1976d2',
                                    color: '#ffffff',
                                    width: '40px',
                                    height: '40px'
                                }}
                            >
                                <Avatar
                                    style={{
                                        backgroundColor: 'rgb(0 242 255)',
                                        color: '#000',
                                        fontSize: 21,
                                        fontWeight: 'bold',
                                        borderRadius: '300px !important'
                                    }}
                                >
                                    {this.getInitials(this.state.user?.firstName + ' ' + this.state.user?.lastName || this.state.user?.email)}
                                </Avatar>
                            </IconButton>
                            <Menu
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleProfileMenuClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <ListSubheader style={{lineHeight: '20px', height: '20px'}}>{this.state.user?.firstName + ' ' + this.state.user?.lastName}</ListSubheader>
                                <MenuItem onClick={this.handleMyProfile}>My Profile</MenuItem>
                                <Divider />
                                <MenuItem onClick={this.handleLogout}>Logout</MenuItem>
                            </Menu>
                        </Toolbar>
                    </AppBar>
                    <Drawer
                        anchor={window.innerWidth < 960 ? 'top' : 'left'}
                        variant="permanent"
                        className={classNames(classes.drawer, {
                            [classes.drawerOpen]: this.state.open,
                            [classes.drawerClose]: !this.state.open,
                        })}
                        classes={{
                            paper: classNames({
                                [classes.drawerOpen]: this.state.open,
                                [classes.drawerClose]: !this.state.open,
                            }),
                        }}
                        open={this.state.open}
                    >
                        <div style={{display: 'block', margin: '7px auto', width: 50}}>
                            <div className={classes.toolbar}>
                                <IconButton onClick={this.toggleNavDrawer} style={{backgroundColor: '#6e7b8e', color: '#ffffff'}}>
                                    {!this.state.open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
                                </IconButton>
                            </div>
                        </div>
                        {this.props.onSyncDatabase && this.state.open && (
                            <div style={{padding: '0 8px', height: '60px'}}>
                                {/* Spacer div to maintain layout */}
                            </div>
                        )}
                        {this.props.onSyncDatabase && !this.state.open && (
                            <div style={{display: 'flex', justifyContent: 'center', width: '100%', height: '60px'}}>
                                {/* Spacer div to maintain layout */}
                            </div>
                        )}
                        <NavigationDrawer open={this.state.open} toggleDrawerCallback={this.toggleNavDrawer}
                                          toggleOrgDrawer={this.toggleOrgDrawer}/>
                    </Drawer>
                    <div className={`dashboardBody ${!this.state.open ? 'collapsed' : ''}`}>
                        {this.props.children}
                        <div style={{width: '100%', display: 'inline-block', color: '#FFF'}}>
                            <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                        </div>
                    </div>
                    {this.props.onSyncDatabase && (
                        <Button
                            className={this.state.open ? classes.syncButtonDrawerOpen : classes.syncButtonDrawerClosed}
                            onClick={this.props.onSyncDatabase}
                            variant="contained"
                            startIcon={<SyncIcon />}
                            aria-label="sync database"
                            title="Sync Database"
                        >
                            {this.state.open ? 'Sync Database' : ''}
                        </Button>
                    )}
                </div>
            </ThemeProvider>
        );
    }

    logout = () => {
        const authService = AuthenticationService.getInstance();
        authService.logout();
    }
}

DashboardTemplate = withRouter(DashboardTemplate);
DashboardTemplate = withStyles(styles, {withTheme: true})(DashboardTemplate);
export default DashboardTemplate;
